/**
 * Shows markers for batches that were edited in admin or had enrollment moves via change-batch.
 * Relies on API fields: `metadataEdited`, `enrollmentMoveOutCount`, `enrollmentMoveInCount`.
 */
const BatchChangeIndicators = ({ batch, className = '' }) => {
  const edited = Boolean(batch?.metadataEdited);
  const movesOut = Number(batch?.enrollmentMoveOutCount) || 0;
  const movesIn = Number(batch?.enrollmentMoveInCount) || 0;

  if (!edited && movesOut <= 0 && movesIn <= 0) return null;

  return (
    <div className={`flex flex-wrap items-center gap-1.5 ${className}`}>
      {edited ? (
        <span
          className="inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-xs font-semibold bg-amber-100 text-amber-900 dark:bg-amber-900/40 dark:text-amber-100 border border-amber-200/80 dark:border-amber-700"
          title="Batch name, dates, status, or other settings were changed after this batch was created."
        >
          <span aria-hidden>✎</span> Edited
        </span>
      ) : null}
      {movesOut > 0 ? (
        <span
          className="inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-xs font-semibold bg-violet-100 text-violet-900 dark:bg-violet-900/40 dark:text-violet-100 border border-violet-200/80 dark:border-violet-700"
          title="Enrollments still on this batch whose remarks say the student moved to another batch."
        >
          <span aria-hidden>↗</span> {movesOut} move{movesOut !== 1 ? 's' : ''} out
        </span>
      ) : null}
      {movesIn > 0 ? (
        <span
          className="inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-xs font-semibold bg-sky-100 text-sky-900 dark:bg-sky-900/40 dark:text-sky-100 border border-sky-200/80 dark:border-sky-700"
          title="Enrollments on this batch created by change-batch from another batch (Joined from… in remarks)."
        >
          <span aria-hidden>↙</span> {movesIn} move{movesIn !== 1 ? 's' : ''} in
        </span>
      ) : null}
    </div>
  );
};

export default BatchChangeIndicators;
